import { useMutation } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import {
  GetHomeScreenBannerImageUploadUrl,
  GetHomeScreenBannerImageUploadUrlVariables
} from './__generated__/GetHomeScreenBannerImageUploadUrl'

const MUTATION = gql`
  mutation GetHomeScreenBannerImageUploadUrl($id: String!) {
    getHomeScreenBannerImageUploadUrl: getHomeScreenBannerImageUploadUrlV2(id: $id) {
      ... on HomeScreenBannerImageResponseV2 {
        url
      }
      ... on HomeScreenBannerErrorV2 {
        type
        error
      }
    }
  }
`

export const useGetHomeScreenBannerImageUploadUrl = () =>
  useMutation<GetHomeScreenBannerImageUploadUrl, GetHomeScreenBannerImageUploadUrlVariables>(MUTATION)
